import React from 'react';
import { getContext } from 'common';
import Typography, { TypographyProps } from 'components/Typography';
import Styled from './styles';

export interface LaunchPadTileTitleProps extends React.ComponentPropsWithRef<'div'> {
  /** Place content here. */
  children: React.ReactNode;
  /** Forward typography props to the nested Typography component.  */
  typographyProps?: Partial<TypographyProps>;
}

/** LaunchPad tile title */
const LaunchPadTileTitle = React.forwardRef<HTMLElement, LaunchPadTileTitleProps>((props: LaunchPadTileTitleProps, ref) =>
  getContext(({ RTL }) => {
    const { children, typographyProps, ...otherProps } = props;
    return (
      <Styled.LaunchPadTileTitle $rtl={RTL} ref={ref} {...otherProps}>
        <Typography variant="BODY" {...typographyProps}>
          {children}
        </Typography>
      </Styled.LaunchPadTileTitle>
    );
  }));

LaunchPadTileTitle.displayName = 'LaunchPadTileTitle';
LaunchPadTileTitle.defaultProps = {
  typographyProps: undefined
};

/* Exports */
export { LaunchPadTileTitle as default };
